import isLoading from './is-loading'
import addError from './add-error'
import requestNewMfaFactor from '@app/request/new-mfa-factor'

export default (params) => {
  return async (dispatch) => {
    dispatch(isLoading('new-mfa-factor'))
    const result = await requestNewMfaFactor(params)
    if (result.error) {
      dispatch(addError(result.error))
    }

    dispatch(isLoading('new-mfa-factor', true))
    return result
  }
}
